import React, { useContext, useEffect, useRef } from 'react';
import { type RestSpeechBubble1Modal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import { RefsContext } from '@bbkFunnelUtils/refs.context';
import ModalPerson from './sections/person';
import SimpleModalTitle from './sections/simple-title';

type Props = Pick<RestSpeechBubble1Modal['requires'], 'info' | 'person'> & {
  modal: RestSpeechBubble1Modal;
  actions: React.ReactNode;
};
const SpeechBubble: React.FC<Props> = (props) => {
  const {
    modal: { id },
    info,
    person,
    actions,
  } = props;

  const refsPrefix = id;
  const refsCtx = useContext(RefsContext);
  const personRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => refsCtx?.addRef(`${refsPrefix}-person`, personRef),
    [personRef]
  );
  const descRef = useRef<HTMLDivElement>(null);
  useEffect(() => refsCtx?.addRef(`${refsPrefix}-desc`, descRef), [descRef]);
  const actionsRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => refsCtx?.addRef(`${refsPrefix}-actions`, actionsRef),
    [actionsRef]
  );

  return (
    <div className="speech-bubble-1">
      <div className="SBContainer">
        <div className="left" ref={personRef}>
          <ModalPerson person={person} />
        </div>
        <div className="right">
          <div className="quote" ref={descRef}>
            <SimpleModalTitle>
              <CustomerHtml value={info.title} />
            </SimpleModalTitle>
            <div className="details">
              <CustomerHtml value={info.details} />
            </div>
            {info.question && <div className="question">{info.question}</div>}
            <div className="arrow-down" />
          </div>
          <div className="action" ref={actionsRef}>
            {actions}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeechBubble;
